import mapper from '../_endpoints'
import { usePost } from '../_hooks/usePost'

export const useSupportService = () => {
  const [isSending, postRaiseTicket] = usePost()

  const raiseTicket = async (item: any) => {
    const { title, applicationID, applicationName, subject, description, files, supportType } = item

    const response = await postRaiseTicket({
      url: mapper.notifications.raiseTicket,
      data: {
        title,
        applicationID,
        applicationName,
        subject,
        description,
        files,
        supportType
      }
    })
    return response
  }

  return { isSending, raiseTicket }
}
